import style from './style.scss';
import { useEffect, useState } from "preact/compat";

function findGetParameter(parameterName) {
	var result = null,
		tmp = [];
	location.search
		.substr(1)
		.split("&")
		.forEach(function (item) {
			tmp = item.split("=");
			if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
		});
	return result;
}

const Chatwrp = ({ chatID, callback, expandOnFirstClick }) => {
	const [isFullscreen, setIsFullscreen] = useState(false);
	const [isClosing, setIsClosing] = useState(false);

	if (!chatID) chatID = (typeof window !== 'undefined' && findGetParameter('id')) ? findGetParameter('id') : 13818;

	useEffect(() => {
		// set listeners to events only if window is set (prerender thing) and if callbacks are requested thru params
		if (typeof window !== 'undefined' && callback) {
			window.addEventListener('message', handleMessage, false);
			return () => {
				window.removeEventListener('message', handleMessage, false);
			};
		}
	}, []);

	const handleMessage = (e) => {
		if (e.origin !== 'https://chat.querlo.com' ||
			e.data.querloMessageType !== 'clientEvent') {
			return;
		} else {
			callback(e.data.command, e);
		}
	}

	const handleOverlayClick = () => {
		setIsFullscreen(true);
	};

	const handleRestore = () => {
		setIsClosing(true);
		setTimeout(() => {
			setIsFullscreen(false);
			setIsClosing(false);
		}, 400); // Match animation duration
	};

	return <div class={`${style.chatwrp} ${isFullscreen ? style.fullscreen : ''} ${isClosing ? style.closing : ''}`}>
			{expandOnFirstClick && !isFullscreen && (
				<div class={style.overlay} onClick={handleOverlayClick} />
			)}
			{isFullscreen && (
				<button class={style.restoreBtn} onClick={handleRestore}>
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
						<path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path>
					</svg>
				</button>
			)}
			<iframe src={"https://chat.querlo.com/" + chatID} allow="microphone;camera;midi;encrypted-media;" frameBorder="0"></iframe>
		</div>
}

export default Chatwrp;
